<app-navbar (loanListEvent)="displayLoanList($event)"></app-navbar>
<div class="body-background">
    <div class="container-fluid container-result">
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <form [formGroup]="OneForm">
                    <div class="loanfilter-box l-box">
                        <div class="filter-heading">Loan Purpose</div>
                        <div class="d-flex">

                            <div class="filter-text margin-0" [ngClass]="PurposeType==PurposeTypeEnum.HomeImprovements?'active-filter':''" (click)="LoanPurpose(PurposeTypeEnum.HomeImprovements,'Home Improvements')">
                                Home Improvements</div>
                            <div class="filter-text margin-0" [ngClass]="PurposeType==PurposeTypeEnum.CarLoan?'active-filter':''" (click)="LoanPurpose(PurposeTypeEnum.CarLoan,'Car Loan')">Car Loan
                            </div>
                           
                        </div>
                        <div class="d-flex">

                            <div class="filter-text margin-0" [ngClass]="PurposeType==PurposeTypeEnum.DebtConsolidation?'active-filter':''" (click)="LoanPurpose(PurposeTypeEnum.DebtConsolidation,'Debt Consolidation')">Debt Consolidation
                            </div>
                            <div class="filter-text" [ngClass]="PurposeType==PurposeTypeEnum.Others?'active-filter':''" (click)="LoanPurpose(PurposeTypeEnum.Others,'Others')">Other</div>
                        </div>
                        <div class="box-border"></div>
                        <div class="d-flex justify-content-between padding-box">
                            <div class="filter-para">Loan Amount</div>
                          
                            <div id="orgval">
                              
                                <input type="text" id="chang" class="value-orange org-val" placeholder="" oninput="javascript: if (this.value > 25000){this.value = 25000;}" step="500" min="500" max="25000" #sliderAmount pattern="\d*" (blur)="LoanAmounts($event)" value="£ {{Amount}}">
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="box-m-1">£500</div>
                            <div class="slidecontainer">
                                <input type="range" formControlName="LoanAmount" step="500" (input)="changeSlider($event,'LoanAmount')" (change)="changeSlider($event,'LoanAmount')" min="500" max="25000">
                            </div>
                            <div class="box-m-1">£25000</div>
                        </div>
                        <div class="box-border"></div>

                        <div class="d-flex justify-content-between padding-box">
                            <div class="filter-para">Loan Term</div>
                            <div class="value-orange width-y">{{TermYear}}  <span class="space-new" [innerHTML]="TermTypes"> </span></div>
                    </div>
                        <div class="d-flex">
                            <div class="box-m-1">6 mths</div>
                            <div class="slidecontainer">
                                <input type="range" formControlName="LoanTerm" step="6" (input)="changeSlider($event,'LoanTerm')" (change)="changeSlider($event,'LoanTerm')" min="6" max="120">
                            </div>
                            <div class="box-m-1">10 yrs</div>
                        </div>

                        <div class="btn-container">
                            <button class="btn btn-filter" (click)="GetEligibilityBasedLoan(1)" type="submit">
                <div class="container" *ngIf="IsUpdateResult">
                  <div style="margin:1% auto;">
                    <div class="spinner-border custom-spinner-border" role="status"></div>
                  </div>
                </div>
                <span *ngIf="!IsUpdateResult">Update Results</span>
              </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-lg-9 col-md-9 col-sm-12 col-padding">
                <div *ngIf="LoanList.length > 0">
                    <div class="box-1">
                        <div class="d-flex">
                            <img src="{{imgSrc}}info-sign.svg" alt="info-arrow" class="img-icon img-fluid">
                            <div class="text-box-1">Good news, we have eligible loans for you. If you’re not seeing many results, try changing the amount requested. Assumed borrowing of <b>£{{TitleAmount}}</b> over
                                <b>{{TitleTermYear}} {{TitleTermTypes}}</b>.
                                <span class="modify-r" (click)=" modal(filtermobilemodel)">Modify Results</span>
                            </div>
                        </div>
                    </div>

          <div class="d-flex justify-content-between" id="showing-total">
            <div class="showing">Showing total <b>{{LoanList.length}} results</b> sorted on <b>{{SortByName}}</b></div>
            <div class="d-flex">
              <div class="sort">Sort by</div>

                            <select class="new-input form-select select-css" (change)="Sorting($any($event.target).value)">
                <option value="EligibilityPercentageD">
                  Eligibility (High to Low)
                </option>

                <option value="AnnualInterestAPRA">
                  Representative APR (Low to High)
                </option>

                <option value="MonthlyRepaymentA">
                  Monthly Payment (Low to High)
                </option>

                <option value="TotalRepayableAmountA">
                  Total Repayable (Low to High)
                </option>

                <option value="providerNameA">
                  Loan Name (A-Z)
                </option>

                <option value="providerNameD">
                  Loan Name (Z-A)
                </option>

              </select>
                        </div>
                    </div>

                    <div *ngFor="let loanItem of LoanList index as i">

                        <div class="box-2">
                            <div class="row">
                                <div class="col-lg-5 col-md-5 col-sm-12 margin-1">
                                    <div [ngClass]="loanItem.eligibilityPercentage < 19 ? 'opacity-new box-3' : 'box-3'">
                                        <div class="d-flex">
                                            <img src="{{loanItem.imgUrl}}" alt="logo" class="img-fluid img-logo">
                                            <div>
                                                <div class="logo-text">{{loanItem.providerName}}</div>
                                                <div class="d-flex">
                                                    <div class="not-eligible" *ngIf="loanItem.eligibilityPercentage < 19">Not Eligible</div>
                                                    <div class="btn-eligible" *ngIf="loanItem.eligibilityPercentage > 19">Eligible</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-7 col-md-7 col-sm-12">
                                    <div [ngClass]="loanItem.eligibilityPercentage < 19 ? 'opacity-new box-4' : 'box-4'">
                                        <div class="d-flex justify-content-between">
                                            <div class="margin-2 new-sb">
                                                <div class="apr-text">{{loanItem.totalRepayableAmount | defaultCurrency}}</div>
                                                <div class="apr-b ">Total amount repayable</div>
                                            </div>

                                            <div class="margin-2">
                                                <div class="apr-text">{{loanItem.annualInterestAPR}}% APR</div>
                                                <div class="d-flex">
                                                    <!-- <button class="btn btn-guaranteed" type="submit">Guaranteed Rate</button>
                    <img src="{{imgSrc}}info-i-icon.svg" alt="logo" class="img-fluid"> -->
                                                    <div class="reypaymentRate">

                                                        <button class="btn" [ngClass]="loanItem.repaymentRateType =='Guaranteed' ? 'btn-guaranteed' : 'btn-variable'" type="submit">{{loanItem.repaymentRateType}}
                              Rate</button>
                                                    </div>

                                                    <div *ngIf="loanItem.repaymentRateType =='Guaranteed'">
                                                        <div class="img-tiptool tooltip">
                                                            <img class="img-fluid" src="{{imgSrc}}info-i-icon.svg" alt="logo">
                                                            <div class="bottom">
                                                                {{toolTipGuaranteedRate}}
                                                                <i></i>
                                                            </div>
                                                        </div>


                                                    </div>
                                                    <div *ngIf="loanItem.repaymentRateType =='Variable'">
                                                        <div class="img-tiptool tooltip">
                                                            <img class="img-fluid" src="{{imgSrc}}info-i-icon.svg" alt="logo">
                                                            <div class="bottom">
                                                                {{toolTipVariableRate}}
                                                                <i></i>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
  </div>

                      <div>
                        <div class="apr-text text-bs">{{loanItem.monthlyRepayment | defaultCurrency}} p/m</div>
                        <div class="apr-b text-ns">Over {{TitleTermYear}} months </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div [ngClass]="loanItem.eligibilityPercentage < 19 ? 'opacity-new text-rep-mobile' : 'text-rep-mobile'"><b>Representative Example:</b> {{loanItem.representativeExample}}</div>
              <div class="d-flex justify-content-between">
                <div class="text-rep" [ngClass]="loanItem.eligibilityPercentage < 19 ? 'opacity-new text-rep' : 'text-rep'"><b>Representative Example:</b> {{loanItem.representativeExample}}</div>
                <div class="btn-two d-flex">
                  <button type="submit" class="btn button-key" (click)="open(keyfactmodel,loanItem.cardId)">Key
                    Facts</button>
                                    <button type="submit" [ngClass]="loanItem.eligibilityPercentage < 19 ? 'opacity-new button-apply' : 'button-apply'" [disabled]="loanItem.eligibilityPercentage < 19 " class="btn" (click)="ApplyLoan(loanItem.linkUrl ?? '', loanItem.logId,loanItem.cardId,loanItem.providerName,loanItem.correlationId)">Apply
                    Now</button>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>

                <div class="loader-main" *ngIf="LoanList.length == 0">
                    <div class="text-center">
                        <div class="spinner-border spinner-border-sm spinner-loader" role="status"></div>
                        <br>
                        <p class="loading-msg">Please wait while we are gathering data …</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<!-- Modal -->
<ng-template #keyfactmodel let-modal>
    <div class="modal-center">
        <div class="modal-header">
            <h5 class="modal-title key-fact-title" id="keyfactmodelLabel">Key Facts</h5>
            <button type="button" class="close btn btn-close" (click)="popUpClose()" data-dismiss="modal" aria-label="Close"><img src="{{imgSrc}}close.svg" alt="logo"
          class="img-fluid"></button>
    </div>
    <div class="modal-body">
      <div class="container-points">
        <ul class="ul-keyfacts">
          <li class="li-keyfact" *ngIf="(keyfact.ageMin != null)">
            {{keyfact.ageMin}}
          </li>
          <li class="li-keyfact" *ngIf="(keyfact.existingCustomersOnly != null)">
            {{keyfact.existingCustomersOnly}}
          </li>
          <li class="li-keyfact" *ngIf="(keyfact.earlyRepaymentPenalty != null)">
            {{keyfact.earlyRepaymentPenalty}}
          </li>
          <li class="li-keyfact" *ngIf="(keyfact.fundsAvailableOnSameDay != null)">
            {{keyfact.fundsAvailableOnSameDay}}
          </li>
          <li class="li-keyfact" *ngIf="(keyfact.defermentAllowed != null)">
            {{keyfact.defermentAllowed}}
          </li>
        </ul>
      </div>
      <div class="text-bottom-box">
         <div class="text-center text-bottom"> Additional <a href="{{Additional_CriteriaLink}}" target="_blank"> acceptance criteria</a>  may apply.</div> 
      </div>
    </div>
  </div>
</ng-template>

<ng-template #filtermobilemodel let-modal>
    <div class="modal-center">
        <div class="modal-header">
            <h5 class="modal-title key-fact-title" id="keyfactmodelLabel">Filter Results</h5>
            <button type="button" class="close btn btn-close" (click)="popUpClose()" data-dismiss="modal" aria-label="Close"><img src="{{imgSrc}}close.svg" alt="logo"
          class="img-fluid bw"></button>
        </div>
        <div class="modal-body m-b">
            <form [formGroup]="OneForm">
                <div class="loanfilter-box loan-box-mobile">
                    <div class="filter-heading">Loan Purpose</div>
                    <div class="d-flex">

                        <div class="filter-text margin-0" [ngClass]="PurposeType==PurposeTypeEnum.HomeImprovements?'active-filter':''" (click)="LoanPurpose(PurposeTypeEnum.HomeImprovements,'Home Improvements')">
                            Home Improvements</div>
                        <div class="filter-text margin-0" [ngClass]="PurposeType==PurposeTypeEnum.CarLoan?'active-filter':''" (click)="LoanPurpose(PurposeTypeEnum.CarLoan,'Car Loan')">Car Loan
                        </div>
                        
                    </div>
                    <div class="d-flex">
                        <div class="filter-text margin-0" [ngClass]="PurposeType==PurposeTypeEnum.DebtConsolidation?'active-filter':''" (click)="LoanPurpose(PurposeTypeEnum.DebtConsolidation,'Debt Consolidation')">Debt Consolidation
                        </div>
                        <div class="filter-text" [ngClass]="PurposeType==PurposeTypeEnum.Others?'active-filter':''" (click)="LoanPurpose(PurposeTypeEnum.Others,'Others')">Other</div>
                    </div>
                    <div class="box-border"></div>
                    <div class="d-flex justify-content-between padding-box">
                        <div class="filter-para">Loan Amount</div>
                       
                        <div>
                            <input type="text" id="chang" class="value-orange org-val" placeholder="" oninput="javascript: if (this.value > 25000){this.value = 25000;}" step="500" min="500" max="25000" #sliderAmount pattern="\d*" (blur)="LoanAmounts($event)" value="£ {{Amount}}">
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="slidecontainer">
                            <input type="range" formControlName="LoanAmount" step="500" (input)="changeSlider($event,'LoanAmount')" (change)="changeSlider($event,'LoanAmount')" min="500" max="25000">
                        </div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div class="box-m-1">£500</div>
                        <div class="box-m-1 margin-new-y">£25000</div>
                    </div>
                    <div class="box-border"></div>

                    <div class="d-flex justify-content-between padding-box">
                        <div class="filter-para">Loan Term</div>
                        <div class="value-orange width-y">{{TermYear}}  <span class="space-new" [innerHTML]="TermTypes"> </span></div>
                    </div>
                    <div class="d-flex">
                        <div class="slidecontainer">
                            <input type="range" formControlName="LoanTerm" step="6" (input)="changeSlider($event,'LoanTerm')" (change)="changeSlider($event,'LoanTerm')" min="6" max="120">
                        </div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div class="box-m-1">6 m</div>
                        <div class="box-m-1 margin-new-y">10 yrs</div>
                    </div>
                    <div class="btn-container">
                        <button class="btn btn-filter" (click)="GetEligibilityBasedLoan(1); popUpClose()" type="submit">
              <div class="container" *ngIf="IsUpdateResult">
                <div style="margin:1% auto;">
                  <div class="spinner-border custom-spinner-border" role="status"></div>
                </div>
              </div>
              <span *ngIf="!IsUpdateResult">Update Results</span>
            </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-template>
<app-footer></app-footer>